import { useEffect } from "react";
import { useAuth } from "@clerk/react";
import { setAuthTokenGetter } from "@/api/client";

// Mounted once under ClerkProvider. Hands the API client a closure over
// Clerk's getToken so every request carries the current session JWT.
export function InstallAuthToken(): null {
  const { getToken } = useAuth();
  useEffect(() => {
    setAuthTokenGetter(async () => {
      try {
        return await getToken();
      } catch {
        return null;
      }
    });
    return () => setAuthTokenGetter(async () => null);
  }, [getToken]);
  return null;
}
